import { SvgRatingStar } from "assets";
import {
  black,
  gray1,
  gray3,
  gray4,
  gray5,
  gray6,
  gray7,
  gray8,
  mainColor,
} from "assets/styleUtils";
import { EmptyView, HallInfo, TextSection, TypeText } from "components";
import {
  getCompanyDetail,
  getCompanyReviewList,
  getCompanyReviewPhotoList,
  ICompany,
  ICompanyReview,
  ICompanyReviewPhoto,
} from "data/company";
import { THallList } from "pages/WeddingHall/WeddingHall";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { headerAndBottomVisibleState, userSelectHall } from "recoil/atoms";
import ReviewItem from "./ReviewItem";
import styles from "./style.module.css";
import { toast, ToastContainer } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { getParameterObject } from "utils/common";
import { recombinationListState } from "recoil/company";

type TInfo = "정보" | "상품" | "리뷰";

export default function CompanyDetailPage() {
  const navigation = useNavigate();
  const headerAndBottomVisible = useRecoilValue(headerAndBottomVisibleState);
  const { isBottom } = headerAndBottomVisible;
  const [companyData, setCompanyData] = useState<ICompany>();
  const [selectInfo, setSelectInfo] = useState<TInfo>("상품");
  const [reviewList, setReviewList] = useState<{
    page: IPage;
    review: ICompanyReview[];
    totalRating: string;
  }>();
  const [isLoding, setIsLoding] = useState(false);
  const [reviewPhotoList, setReviewPhotoList] = useState<ICompanyReviewPhoto[]>(
    []
  );
  const [contructorList, setContructorList] = useState<THallList[]>([]);
  const [selectArray, setSelectArray] = useRecoilState(userSelectHall);
  const userHallData = useRecoilValue(userSelectHall);
  const [swiperRef, setSwiperRef] = useState<SwiperCore>();
  const [paging, setPaging] = useState(0);
  const { search } = useLocation();
  const [category, setCategory] = useState("");
  const { no } = getParameterObject({ url: search });
  const recombinationList = useRecoilValue(recombinationListState);

  const booked = recombinationList.filter(
    (data) => data.status !== 3 && data.contructor_no === companyData?.no
  );

  const selectComplete = contructorList.map((_selectItem) => {
    const filteredHalls =
      _selectItem.hall?.filter((_hall) => _hall.checked) || [];
    return {
      name: _selectItem.name,
      contructor_no: _selectItem.contructor_no,
      hall: filteredHalls,
    };
  });
  const containsEmptyArray = selectComplete.filter((array, idx) => {
    if ((array || []).hall.length === 0) {
      return selectComplete[idx].name;
    }
  });

  useEffect(() => {
    if (no) {
      getCompanyData(Number(no));
    } else {
      navigation(-1);
    }
  }, []);

  useEffect(() => {
    if (companyData?.review && companyData.review.review.length > 0) {
      setReviewList(companyData.review);
    }
    if (companyData?.no) {
      getReviewPhotoData();
    }
  }, [companyData]);

  async function getCompanyData(no: number) {
    try {
      const {
        data: { result },
      } = await getCompanyDetail(no);
      if (result) {
        setCompanyData(result);
        setCategory(result.category);
        const newDataState = () => {
          const userHall = userHallData.find(
            (hall: THallList) => hall.name === result.name
          );
          const checked = userHall ? userHall?.checked : false;

          return {
            key: result.no,
            name: result.name,
            imgUrl: result.photo[0]?.img_url || "",
            checked: checked,
            contructor_no: result.no,
            hall: result.hall_list || [],
          };
        };
        setContructorList([{ ...newDataState(), checked: true }]);
      }
    } catch (error) {
      console.log("getCompanyData error", error);
    }
  }

  async function getReviewData(_page: number) {
    try {
      if (_page === 1) {
        setIsLoding(true);
      }
      const { data } = await getCompanyReviewList({
        page: String(_page),
        contructor_no: String(companyData?.no),
      });
      const { review, page } = data.result || {};

      if (data && review && page) {
        if (_page <= 1) {
          setReviewList(data.result);
        } else {
          setReviewList({
            ...data.result,
            review: [...(reviewList?.review || []), ...review],
          });
        }
      }
    } catch (error) {
      console.warn("getReviewData error", error);
    } finally {
      setTimeout(() => setIsLoding(false), 500);
    }
  }

  async function getReviewPhotoData() {
    try {
      const { data } = await getCompanyReviewPhotoList({
        contructor_no: String(companyData?.no),
      });
      if (data.result) {
        setReviewPhotoList(data.result);
      }
    } catch (error) {
      console.warn("getReviewPhotoData error", error);
    }
  }

  return (
    <div>
      {!companyData?.thumb_photo[0] ? (
        <div style={{ width: "100%", height: "260px" }}>
          <EmptyView content="사진이 없습니다" />
        </div>
      ) : (
        <div>
          <>
            <Swiper
              spaceBetween={30}
              className="mySwiper"
              slidesPerView="auto"
              threshold={10}
              pagination={{
                dynamicBullets: true,
              }}
              onSwiper={setSwiperRef}
              modules={[Pagination]}
              onSlideChange={(swiper) => setPaging(swiper.activeIndex)}
              style={{ backgroundColor: black }}
            >
              {companyData.thumb_photo?.map((_photo, index) => {
                return (
                  <SwiperSlide key={index}>
                    <img
                      src={_photo.img_url}
                      style={{
                        height: "375px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    ></img>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </>
          <div
            style={{
              marginTop: "24px",
              padding: "0 16px 20px 16px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div style={{ fontSize: "12px", color: gray3 }}>
                  {(companyData?.address || "주소정보없음")
                    .split(" ")
                    .filter(({}, i) => i < 2)
                    .join(" ")}
                </div>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    margin: "8px 0",
                  }}
                >
                  {companyData?.name}
                </div>
                <div style={{ fontSize: "12px", color: gray4 }}>
                  {companyData?.tag
                    .split(",")
                    .reduce<string>((acc, cur) => acc + `#${cur} `, "")}
                </div>
              </div>
              <div
                className={styles.flexCenter}
                style={{
                  width: "50px",
                  flexDirection: "column",
                }}
              >
                {/* <a

                //TODO
                // href={`https://deeplink.makemywedding.kr/?type=companydetail&no=${companyData?.no}`}
                >
                  <img
                    src="/images/share.png"
                    style={{ marginRight: "4px", width: "24px" }}
                  />
                </a> */}
              </div>
            </div>
            {companyData?.additinal && companyData.additinal.length > 0 ? (
              <div
                style={{
                  padding: "24px 0",
                  margin: "24px 0",
                  borderTop: `1px solid ${gray7}`,
                  borderBottom: `1px solid ${gray7}`,
                }}
              >
                <div
                  style={{
                    marginBottom: "8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{
                      marginRight: "4px",
                      width: "20px",
                      height: "18px",
                    }}
                    src="/images/ticket.png"
                  />
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: mainColor,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      멕마웨 {companyData.category} 혜택
                    </div>
                  </div>
                </div>
                <>
                  {companyData.additinal.map(({ context }, index) => (
                    <TextSection data={context} key={index} />
                  ))}
                </>
              </div>
            ) : (
              <div
                style={{
                  margin: "0 16px",
                }}
              />
            )}
          </div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          height: "44px",
          padding: "0 24px",
          justifyContent: "space-between",
        }}
      >
        {(["상품", "정보", "리뷰"] as TInfo[]).map((text, index) => {
          const isSelect = text === selectInfo;
          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderBottom: isSelect ? `2px solid ${gray1}` : "",
                cursor: "pointer",
              }}
              onClick={() => setSelectInfo(text)}
              key={index}
            >
              <div
                style={{
                  color: isSelect ? gray1 : gray5,
                  fontWeight: "500",
                  display: "flex",
                }}
              >
                {text}
                {text === "리뷰" &&
                  reviewList?.page.maxcnt &&
                  reviewList?.page.maxcnt > 0 && (
                    <div color={isSelect ? gray1 : gray5}>
                      ({reviewList?.page.maxcnt})
                    </div>
                  )}
              </div>
            </div>
          );
        })}
      </div>
      <div
        style={{
          padding: "24px 16px",
        }}
      >
        {selectInfo === "상품" ? (
          category === "웨딩홀" ? (
            <>
              {(companyData?.photo || []).length > 0 ? (
                <div style={{ background: "#f2f9f8", padding: "13px 12px" }}>
                  <HallInfo
                    hall={contructorList[0].hall || []}
                    contructor_no={Number(no)}
                    setValue={({ contructor_no: no, contructor_hall_no }) => {
                      const contructorData = contructorList.map(
                        (list, index) => {
                          return {
                            ...list,
                            hall: list.hall?.map((_hall, index) =>
                              _hall.no === contructor_hall_no
                                ? {
                                    ..._hall,
                                    checked: !_hall.checked,
                                  }
                                : _hall
                            ),
                          };
                        }
                      );
                      setContructorList(contructorData);
                      if (!contructorData) {
                        return;
                      }
                    }}
                  />
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                  }}
                >
                  <EmptyView content="상품이 없습니다" />
                </div>
              )}
            </>
          ) : (
            <>
              {(companyData?.product || []).length > 0 ? (
                companyData?.product.map((value, i) => {
                  return (
                    <div key={i}>
                      <img
                        key={i}
                        style={{
                          width: "100%",
                          marginBottom: "8px",
                        }}
                        src={value.img_url}
                      />
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                  }}
                >
                  <EmptyView content="상품이 없습니다" />
                </div>
              )}
            </>
          )
        ) : (
          <></>
        )}

        {selectInfo === "정보" && (
          <>
            <div
              style={{
                marginBottom: "10px",
                fontSize: "18px",
                fontWeight: "bold",
                color: mainColor,
              }}
            >
              {companyData?.name}
            </div>
            <div style={{ marginBottom: "24px", lineHeight: "25px" }}>
              <TextSection data={companyData?.coment || ""} />
            </div>
            <TypeText
              title="영업시간"
              content={companyData?.openhour || "정보 없음"}
            />
            <TypeText
              title="주소"
              content={companyData?.address || "정보 없음"}
            />
            <TypeText
              title="홈페이지"
              content={companyData?.homepageUrl || "-"}
              action={companyData?.homepageUrl}
            />
            <TypeText
              title="인스타그램"
              content={companyData?.instagramUrl || "-"}
              action={
                companyData?.instagramUrl &&
                "https://www.instagram.com/" + companyData?.instagramUrl
              }
            />
          </>
        )}
        {selectInfo === "리뷰" && (
          <>
            {reviewList && reviewList.review.length > 0 ? (
              <>
                <div
                  style={{
                    flexDirection: "row",
                    marginBottom: "16px",
                    padding: "0 6px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                      padding: "10px 0",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className={styles.flexCenter}
                      style={{
                        height: "120px",
                        flexDirection: "column",
                        backgroundColor: gray8,
                        borderRadius: "8px",
                        padding: "0 12px",
                      }}
                    >
                      {reviewList?.totalRating && (
                        <>
                          <div
                            style={{
                              lineHeight: "39px",
                              fontSize: "30px",
                              fontWeight: "bold",
                              marginBottom: "5px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {!!reviewList?.totalRating &&
                              parseFloat(reviewList?.totalRating).toFixed(1)}
                          </div>
                          <div
                            style={{
                              flexDirection: "row",
                              height: "20px",
                            }}
                          >
                            <div
                              style={{
                                flexDirection: "row",
                                alignItems: "baseline",
                              }}
                            >
                              <div
                                style={{
                                  alignItems: "baseline",
                                  width: "100px",
                                }}
                              >
                                <SvgRatingStar
                                  width="100px"
                                  height="20px"
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                  }}
                                  fill={mainColor}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "3px",
                          height: "60px",
                          backgroundColor: gray6,
                        }}
                      />
                    </div>
                    <div style={{ flex: 0.5 }}>
                      <div
                        className={styles.flexCenter}
                        style={{
                          border: `1px solid ${mainColor}`,
                          borderRadius: "4px",
                          padding: "12px 16px",
                          marginBottom: "8px",
                        }}
                        // onClick={goReviewWrite}
                      >
                        <div
                          className={styles.flexCenter}
                          style={{
                            fontSize: "14px",
                            lineHeight: "21px",
                            fontWeight: "bold",
                            color: mainColor,
                          }}
                        >
                          리뷰 작성하러 가기
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                          fontWeight: "500",
                          color: gray5,
                          whiteSpace: "pre-line",
                          textAlign: "center",
                        }}
                      >
                        {
                          "일반리뷰 작성시 500포인트 지급 \n 포토리뷰 작성시 1,000포인트 지급"
                        }
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      border: `1px solid ${gray7}`,
                    }}
                  />
                  <div className={styles.paddingBox}>
                    <div
                      style={{
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: gray1,
                      }}
                    >
                      사진 리뷰 모아보기
                    </div>
                  </div>
                  <div className={styles.borderBox} />
                  <div className={styles.paddingBox}>
                    {reviewPhotoList.map((item, i) => (
                      <img
                        key={i}
                        src={item.img_url}
                        className={styles.reviewImage}
                      />
                    ))}
                  </div>
                  <div className={styles.borderBox} />
                  <div className={styles.paddingBox}>
                    리뷰 {reviewList?.page.maxcnt}
                  </div>
                  <div className={styles.borderBox} />

                  <div>
                    {reviewList.review.map((item) => (
                      <div
                        key={item.no}
                        onClick={() =>
                          item.blind_yn === "N" &&
                          navigation(
                            `/company/detail/review/${item.no}/${item.contructor_no}`
                          )
                        }
                      >
                        <ReviewItem review={item} />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "300px",
                }}
              >
                <EmptyView
                  content={
                    "리뷰가 없습니다.\n 첫 번째 리뷰를 작성하러 가볼까요?"
                  }
                  button={{
                    move: `https://deeplink.makemywedding.kr/?type=companydetail&no=${companyData?.no}`,
                    text: "리뷰 작성하러 가기",
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
      <nav className={styles.nav}>
        <div style={{ backgroundColor: gray8 }}>
          <div
            style={{
              display: "flex",
              height: "60px",
              padding: "8px",
              alignItems: "center",
            }}
          >
            {!!isBottom && (
              <a
                className={`${styles.flexCenter} ${styles.buttonStyle}`}
                style={{
                  backgroundColor: black,
                }}
                target="_blank"
                href={`https://deeplink.makemywedding.kr/?type=companydetail&no=${Number(
                  companyData?.no
                )}`}
              >
                어플로 알아보기
              </a>
            )}
            <div
              className={`${styles.flexCenter} ${styles.buttonStyle}`}
              style={{
                backgroundColor: mainColor,
              }}
              onClick={() => {
                if (booked.length > 0) {
                  return toast.error(
                    "이미 예약 신청하신 웨딩홀은 재예약이 불가합니다. \n[내정보-웨딩홀 예약관리]에서 예약 취소 혹은 변경 부탁드립니다."
                  );
                }
                if (containsEmptyArray.length > 0) {
                  toast(containsEmptyArray[0].name + "홀타입 선택해주세요");
                  return;
                } else {
                  setSelectArray(contructorList);
                  navigation(`/wedding/hall?txt=${companyData?.name}`);
                }
              }}
            >
              예약 문의
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
